import type { z } from 'zod';

import type { DeclaredDetails, ReportSchema } from '@ballerine/common';

import { MapPin } from '../../../../common/icons/lucide-adapter';
import { ReportWrapper } from '../../report-shared/components';
import { MerchantDetails } from '../components/MerchantDetails';

export const MerchantDetailsSection = ({
  merchantDetails,
  googleMapsApiKey,
  providedDetails,
  detailsComparison,
}: {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'];
  googleMapsApiKey?: string | null;
  providedDetails?: {
    websiteUrl?: string | null;
    companyName?: string | null;
    merchantId?: string | null;
    countryCode?: string | null;
    declaredDetails?: DeclaredDetails;
  } | null;
  detailsComparison?: string | null;
}) => {
  return (
    <ReportWrapper
      Icon={MapPin}
      tooltip="Business registration and headquarters address information."
      showTooltip={false}
    >
      <MerchantDetails
        merchantDetails={merchantDetails}
        googleMapsApiKey={googleMapsApiKey || ''}
        providedDetails={providedDetails}
        detailsComparison={detailsComparison}
      />
    </ReportWrapper>
  );
};
